import { useRouter } from 'next/router';

import { AcademicLandingPageContainer } from './style';

import { AboutSection } from '@components/organisms/academicLandingPage/aboutSection';
import { BlogSection } from '@components/organisms/academicLandingPage/blogSection';
import { CertificateSection } from '@components/organisms/academicLandingPage/certificateSection';
import { CollaborationSection } from '@components/organisms/academicLandingPage/collaborationSection';
import { CoursesSection } from '@components/organisms/academicLandingPage/coursesSection';
import { LearningInformationSection } from '@components/organisms/academicLandingPage/learningInformationSection';
import { LearnWithUsSection } from '@components/organisms/academicLandingPage/learnWithUsSection';
import { UniversityHistorySection } from '@components/organisms/academicLandingPage/universityHistorySection';
import { useUniversityInformation } from '@helpers/use';

const AcademicLandingPage = () => {
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <AcademicLandingPageContainer>
      <CoursesSection />
      {landingPage?.isCollaborationSectionEnabled && <CollaborationSection />}
      {landingPage?.isLearningInformationSectionEnabled && <LearningInformationSection />}
      {landingPage?.isBlogSectionEnabled && <BlogSection />}
      {landingPage?.isLearnWithUsSectionEnabled && <LearnWithUsSection />}
      {landingPage?.isCheckCertificateSectionEnabled && (
        <CertificateSection templateCertificateImageUrl={landingPage?.templateCertificateImageUrl} />
      )}
      {landingPage?.isHistorySectionEnabled && <UniversityHistorySection />}
      {landingPage?.isAboutSkilllaneSectionEnabled && <AboutSection />}
    </AcademicLandingPageContainer>
  );
};
export default AcademicLandingPage;
